module.exports = __webpack_public_path__ + "img/dynamic-27.26f3252e.jpeg";